import React, { Component, PropTypes } from 'react';
import classes from './component.scss';
import { Actions } from './reducer';
import Dropdown from './components/Dropdown';
import MagnifyingGlassIcon from './components/MagnifyingGlassIcon';
import clickOutside from 'react-click-outside';
import filteredSelector from './filtered-selector';
import cx from 'classNames';

class SearchBar extends Component {
  state = {
    inputValue: '',
    open: false,
    submit: false,
  };

  componentWillReceiveProps(newProps) {
    if (newProps.items.length !== this.props.items.length) {
      this.props.dispatch(Actions.storeAllItems(newProps.items));
      this.resetSelections();
    }
  }

  setStateAndReset(inputValue) {
    this.setState({ inputValue, open: true });
    this.resetSelections();
  }

  resetSelections() {
    this.props.dispatch(Actions.resetSelections());
  }

  handleKeyDown = (e) => {
    const { dispatch } = this.props;
    const inputValue = e.target.value;
    const keyCode = e.which || e.keyCode;
    const filteredLength = this.filteredItems().length;
    if (!keyCode) return;
    switch(keyCode) {
      case 40:
        // arrow down
        dispatch(Actions.selectItemByDirection({ direction: 1, filteredLength }));
        e.preventDefault();
        break;
      case 38:
        // arrow up
        dispatch(Actions.selectItemByDirection({ direction: -1, filteredLength }));
        e.preventDefault();
        break;
      case 39:
        // arrow right
        this.setStateAndReset(inputValue);
        break;
      case 37:
        // arrow left
        this.setStateAndReset(inputValue);
        break;
      case 13:
        this.handleKeyEnter(e)
        break;
      case 27:
        // esc
        this.handleClickOutside();
        break;
      default:
        break;
    }
  }

  handleChange = (e) => {
    this.setStateAndReset(e.target.value);
  }

  handleKeyEnter = (e) => {
    this.props.onKeyEnter(e);
  }

  handleClickItem = (inputValue, item) => {
    this.setState({ inputValue, submit: true, open: false }, () => {
      this.props.onBrandSelect(item);
    });
  }

  handleClickOutside() {
    this.setState({ open: false });
  }

  handleClickInput = () => {
    if (!this.state.open) this.setState({ open: true });
  }

  filteredItems() {
    return filteredSelector([this.state, this.props]);
  }

  render() {
    const { submit, inputValue } = this.state;
    const { selectedItemIndex, direction, lastKeyboardSelectedItemIndex } = this.props.model;
    const items = this.filteredItems();
    const suggestedName = selectedItemIndex !== null && items[lastKeyboardSelectedItemIndex] ? items[lastKeyboardSelectedItemIndex].name : null;
    const value = submit ? inputValue : (suggestedName || inputValue);
    const wrapperClasses = cx({
      [classes.searchBar]: true,
      [classes.clientNotReady]: this.props.staticRender,
    });
    const inputProps = {
      type: 'text',
      name: 'keywords',
      placeholder: 'Search by brand',
      value,
      autoComplete: 'off',
      className: classes.inputSearch,
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      onClick: this.handleClickInput,
      ref: 'inputSearch',
      disabled: this.props.staticRender,
    };

    const dropdownProps = {
      items,
      numVisibleItems: this.props.numVisibleItems || 4,
      selectedItemIndex,
      direction,
      open: this.state.open,
      dispatch: this.props.dispatch,
      handleClickItem: this.handleClickItem,
    };

    return (
      <div className={wrapperClasses} >
        <form className={classes.formSearch} action="/search" acceptCharset="UTF-8" method="get" ref="formSearch" >
          <input name="utf8" type="hidden" value="✓" />
          <input { ...inputProps } />
          <button type="submit" className={classes.submitButton}>
            <MagnifyingGlassIcon />
          </button>
          <Dropdown { ...dropdownProps } />
        </form>
      </div>
    );
  }
}

SearchBar.propTypes = {
  items: PropTypes.array.isRequired,
  numVisibleItems: PropTypes.number,
  model: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onBrandSelect: PropTypes.func.isRequired,
  onKeyEnter: PropTypes.func,
  staticRender: PropTypes.bool,
};

export default clickOutside(SearchBar);



/** WEBPACK FOOTER **
 ** ./shared-components/SearchBar/component.js
 **/